var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJcbLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0a4ea1",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26 16.6c0 1.7-1.4 3.1-3.1 3.1H6V7.4c0-1.7 1.4-3.1 3.1-3.1H26z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#05a551",
  d: "M21.64 5.34c-1.23 0-2.23.99-2.23 2.22v2.31h3.14c.08 0 .16 0 .22.02.71.03 1.24.4 1.24 1.03 0 .5-.36.93-1.02 1.02v.02c.72.05 1.27.46 1.27 1.08 0 .67-.6 1.11-1.41 1.11H19.4v4.52h3.26c1.23 0 2.23-.99 2.23-2.22V5.34z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#05a551",
  d: "M20.5 13.44h1.36l.08-.01a.57.57 0 0 0 .45-.57.6.6 0 0 0-.45-.58l-.16-.01H20.5zm1.28-2.89a.5.5 0 0 1 .45.52c0 .3-.2.49-.45.53H20.5v-1.07h1.16l.07.01h.05Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0a4ea1",
  d: "M9.34 5.34c-1.23 0-2.23.99-2.23 2.22v5.5c.63.3 1.27.5 1.92.5.77 0 1.19-.47 1.19-1.1v-2.6h1.9v2.58c0 1-.62 1.82-2.73 1.82a9.4 9.4 0 0 1-2.29-.28v4.68h3.26c1.23 0 2.23-.99 2.23-2.22V5.34z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ee1c24",
  d: "M15.49 5.34c-1.23 0-2.23.99-2.23 2.22v2.91c.56-.47 1.54-.78 3.12-.7.84.03 1.75.26 1.75.26v.94a4.2 4.2 0 0 0-1.69-.49c-1.2-.08-1.92.5-1.92 1.53 0 1.04.72 1.63 1.92 1.53a4.5 4.5 0 0 0 1.69-.49V14s-.9.23-1.75.27c-1.58.08-2.56-.23-3.12-.7v5.13h3.27c1.22 0 2.22-1 2.22-2.23V5.34H15.5Z"
})));
export default SvgJcbLight;